import { connect } from 'react-redux';
import { getTranslation } from "../../../reducers/common/localization";
import UserSubRoleMissingModal from "./UserSubRoleMissingModal";
import { isUserSubRoleMissing, setUserSubRoleMissing } from '../../../reducers/account/role';

const mapStateToProps = state => {
    return {
        isOpen: isUserSubRoleMissing(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCancel: () => {
            dispatch(setUserSubRoleMissing(false));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSubRoleMissingModal);



// WEBPACK FOOTER //
// ./src/components/commonComponents/userSubRoleMissingModal/UserSubRoleMissingModal.container.js